"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mdList = exports.mdLink = exports.formatNumeral = exports.copyToClipboard = exports.toTitleCase = exports.toSentenceCase = exports.editDistance = void 0;

var _numeral = _interopRequireDefault(require("numeral"));

/* External Libraries */
var editDistance = function editDistance(a, b) {
  if (a.length == 0) return b.length;
  if (b.length == 0) return a.length;
  var matrix = []; // increment along the first column of each row
  // eslint-disable-next-line local-rules/no-c-style-for-loop

  for (var i = 0; i <= b.length; i++) {
    matrix[i] = [i];
  } // increment each column in the first row
  // eslint-disable-next-line local-rules/no-c-style-for-loop


  for (var j = 0; j <= a.length; j++) {
    matrix[0][j] = j;
  } // Fill in the rest of the matrix
  // eslint-disable-next-line local-rules/no-c-style-for-loop


  for (var _i = 1; _i <= b.length; _i++) {
    // eslint-disable-next-line local-rules/no-c-style-for-loop
    for (var _j = 1; _j <= a.length; _j++) {
      if (b.charAt(_i - 1) == a.charAt(_j - 1)) {
        matrix[_i][_j] = matrix[_i - 1][_j - 1];
      } else {
        matrix[_i][_j] = Math.min(matrix[_i - 1][_j - 1] + 1, // substitution
        Math.min(matrix[_i][_j - 1] + 1, // insertion
        matrix[_i - 1][_j] + 1)); // deletion
      }
    }
  }

  return matrix[b.length][a.length];
};

exports.editDistance = editDistance;

var toSentenceCase = function toSentenceCase(s) {
  return s.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, " $1");
};

exports.toSentenceCase = toSentenceCase;

var toTitleCase = function toTitleCase(s) {
  return s.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

exports.toTitleCase = toTitleCase;

var copyToClipboard = function copyToClipboard(str) {
  var body = document.body;

  if (body !== null) {
    var el = document.createElement("textarea");
    el.value = str;
    el.setAttribute("readonly", "");
    el.style.position = "absolute";
    el.style.left = "-9999px";
    body.appendChild(el);
    el.select();
    document.execCommand("copy");
    body.removeChild(el);
  }
};

exports.copyToClipboard = copyToClipboard;

var formatNumeral = function formatNumeral(value) {
  var numeralFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0,0";
  return (0, _numeral["default"])(value).format(numeralFormat).toString();
};

exports.formatNumeral = formatNumeral;

var mdLink = function mdLink(text, url) {
  return "[".concat(text, "](").concat(url, ")");
};

exports.mdLink = mdLink;

var mdList = function mdList(text) {
  return "- ".concat(text);
};

exports.mdList = mdList;